import {useCallback, createElement} from "react";

export const UseCallback = ({next, fn, deps}) => createElement(UseCallbackComp, {fn, next, deps});

const UseCallbackComp = ({fn, deps, next}) => {
    return next(useCallback(fn, deps));
};
